import React, { useState, useEffect } from 'react';
import ReactApexChart from 'react-apexcharts';
import dayjs from 'dayjs';
import quarterOfYear from 'dayjs/plugin/quarterOfYear';

dayjs.extend(quarterOfYear);

const ApexChartQuarterWise = ({ dynamicData }) => {
  const [chartOptions, setChartOptions] = useState({
    series: [
      {
        name: 'Events',
        data: [
          { x: '2024/01/01', y: 0 },
          { x: '2024/02/01', y: 0 },
          { x: '2024/03/01', y: 0 },
          { x: '2024/04/01', y: 0 }
        ],
      },
    ],
    options: {
      chart: {
        type: 'bar',
        height: 480,
      },
      xaxis: {
        type: 'category',
        labels: {
          formatter: function (val) {
            return 'Q' + dayjs(val).quarter();
          },
        },
        group: {
          style: {
            fontSize: '10px',
            fontWeight: 700,
          },
          groups: [
            { title: new Date().getFullYear().toString(), cols: 4 },
        ],
        },
      },
      title: {
        text: 'Count of Events (Quarter wise)',
      },
      tooltip: {
        x: {
          formatter: function (val) {
            return 'Q' + dayjs(val).quarter() + ' ' + dayjs(val).format('YYYY');
          },
        },
      },
    },
  });

  // Update the chart data dynamically
  useEffect(() => {
    if (dynamicData && dynamicData.length > 0) {
      setChartOptions((prevOptions) => ({
        ...prevOptions,
        series: [
          {
            name: 'Events',
            data: dynamicData,
          },
        ],
      }));
    }
  }, [dynamicData]);

  return (
    <div>
      <div id="chart">
        <ReactApexChart
          options={chartOptions.options}
          series={chartOptions.series}
          type="bar"
          height={380}
        />
      </div>
      <div id="html-dist"></div>
    </div>
  );
};

export default ApexChartQuarterWise;
